import { CornerData } from "api/types/sketch";
import { Vector2 } from "api/types/sketch";

export function drawCutStandardCorner(
    path: Path2D,
    i: number,
    current_location: Vector2
): CornerData {
    let first_point: Vector2 | null = null;

    if(i === 0){
        path.moveTo(current_location.X, current_location.Y);
        first_point = current_location;
    }
    else{
        path.lineTo(current_location.X, current_location.Y);
    }

    return {
        first_point: first_point,
        last_point: current_location
    }
}
